import Entrepreneur from '~/modules/entrepreneurs/entities/frontend/entrepreneur'
import defaults from 'lodash/defaults'

/**
 * @param {Entrepreneur} entrepreneur
 * @param {{}} options
 * @param {Boolean} options.fistOnly
 * @param {Boolean} options.lastOnly
 * @param {Boolean} options.possessive
 */
export function getEntrepreneurName (entrepreneur, options) {
  const _options = {
    firstOnly: false,
    lastOnly: false,
    possessive: false,
  }

  const opts = defaults(options, _options)

  const appendPossessive = function (str) {
    if (opts.possessive === true) {
      return str.endsWith('s')
        ? `${str}'`
        : `${str}'s`
    }

    return str
  }

  let name = entrepreneur.displayName

  if (entrepreneur.type === 'individual') {
    if (opts.firstOnly) {
      name = entrepreneur.firstName
    }
    if (opts.lastOnly) {
      name = entrepreneur.lastName
    }
  }

  return appendPossessive(name)
}
